import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { Alert } from '@material-ui/lab';

import { useResetPassword } from '~/hooks/team';
import { Confirmation } from '~/components';
import { l } from '../IdentityShow';
import ResetPasswordButton from './ResetPasswordButton';

interface Props {
  identityId: string;
}

const ResetPassword: FC<Props> = (props) => {
  const { identityId } = props;
  const translate = useTranslate();

  const t = (key: string): string => translate(l(key));

  const resetPasswordMutation = useResetPassword();
  const handleReset = () => {
    if (identityId) {
      return resetPasswordMutation.mutateAsync(identityId);
    }
  };

  return (
    <Confirmation
      onConfirm={handleReset}
      confirmButtonProps={{ loading: resetPasswordMutation.isLoading }}
      confirmationSettings={{
        variant: 'modal',
        modal: { content: <Alert severity='warning'>{t('resetPasswordWarning')}</Alert> },
      }}
    >
      <ResetPasswordButton />
    </Confirmation>
  );
};

export default ResetPassword;
